export default __webpack_public_path__ + "static/media/svg-spritesheet.4cce9e18.svg";